import React from 'react';
import {Container, Row, Col, Button} from 'react-bootstrap';

import './styles/navigatebuttons.css';

export default function navigateButtons() {
  return (
    <>
     <div className="navigate_buttons m-3">
      <Container>
        <Row>
          <Col>
            <div className="navigate_btns d-flex gap-4">
              <div className="navigate_btn">
                <Button className='active'>Dashboard</Button>
              </div>
              <div className="navigate_btn">
                <Button>Recommended</Button>
              </div>
              <div className="navigate_btn">
                <Button>Referral</Button>
              </div>
              <div className="navigate_btn">
                <Button>Cashback</Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
     </div>
    </>
  )
}
